import React from "react";
import styled from "styled-components";
import {List} from "semantic-ui-react";
import { Box } from 'rebass'
import ComponentLoader from '~/components/component-loader';
import loadable from "@loadable/component";

const Description = loadable(() => import(/* webpackChunkName: "videoDescription" */ './description'),{fallback: <ComponentLoader />})

const VideoContainer = styled.div`
  position: relative;
`;

const VideoPlayerContainer = styled.div`
  position: relative;
`;

const VideoFooter = styled.div`
    margin: 0 0 10px;
    border: 0;
    padding: 0 10px 0 15px;
    background: #fff;
    box-shadow: 0 1px 2px rgba(0,0,0,.1);
`;

const VideoTitle = styled.div`
  font-size: 24px;
`;

const Playlist = styled(({ videoHeight, ...rest }) => <List {...rest} />)`
 &&&&&&& {
  height: ${props => (props.videoHeight || 0)}px;
  overflow: auto;
 
   > .item {
     padding: 15px;
     
     &.active {
      background: ${props => props.theme.primary};
      
      &:hover {
        .icon {
          color: rgba(255,255,255,1);
        }
      }
      
      .content {
        .header {
          color: #FFFFFF;   
        }
      }
      
      .icon {
        color: rgba(255,255,255,.7);
      }
     }
     
     .content {
       padding-top: 4px;
     }
   }
 }
`;

const PosterContainer = styled.div`
  display: block;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #fff;
  background-color: #000;
  position: relative;
  font-size: 10px;
  line-height: 1;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 100%;
  max-width: 100%;
  height: 0;
  padding-top: 56.25%;
`;

const Poster = styled.div`
  display: inline-block;
  vertical-align: middle;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: contain;
  background-color: #000000;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  background-image: url('${props => props.image}')
`;

const AlignBox = styled(({ textAlign, ...rest }) => <Box {...rest} />)`
  text-align: ${props => (props.textAlign)}
`;


export {
  Description,
  VideoContainer,
  VideoPlayerContainer,
  VideoFooter,
  VideoTitle,
  Playlist,
  PosterContainer,
  Poster,
  AlignBox
}
